import styled from 'styled-components'

export const StyledContainer = styled.div<{ $isEmbedded: boolean }>`
  position: relative;
  display: flex;
  @media screen and (min-width: 768px) {
    height: ${({ $isEmbedded }) =>
      $isEmbedded ? '100vh' : 'calc(100vh - var(--app-menu-height))'};
  }
`

export const StyledMapContainer = styled.div<{
  $hideHeader: boolean
  $showMobile: boolean
  $showLargeMap: boolean
}>`
  width: 100%;
  display: ${(props) => (props.$showMobile ? 'block' : 'none')};
  position: relative;
  height: ${(props) => (props.$hideHeader ? '100vh' : 'calc(100vh - var(--app-menu-height))')};
  z-index: 1;
  overflow: hidden;

  @media screen and (min-width: 48rem) {
    border-left: ${(props) => (props.$showLargeMap ? 'none' : 'solid 2px var(--blue)')};
    width: ${(props) => (props.$showLargeMap ? '100%' : '50%')};
    display: block;
    position: ${(props) => (props.$showLargeMap ? 'absolute' : 'relative')};
    right: 0;
    bottom: 0;
    top: 0;
    height: auto;
  }

  @media print {
    display: block;
    width: 100%;
    break-inside: avoid;
  }
`

export const StyledSubtitle = styled.p`
  color: var(--blue);
  line-height: 1.5;
  font-size: 0.875rem;
  margin: 0;

  @media screen and (min-width: 48rem) {
    font-size: 1.125rem;
    line-height: 1.6;
  }
`

export const Wrapper = styled.div`
  margin-bottom: 2.5rem;
`
